<p class="dropdown-label">{{ label }}</p>

<mat-form-field
  style="width: 100%"
	appearance="outline"
	class="dropdown"
	floatLabel="always"
>
	<mat-select
		[disableRipple]="true"
		[value]="value"
		(selectionChange)="updateValue($event.value)"
    panelClass="my-custom-panel"
		placeholder="{{ label }}"
	>
		@for (option of options; track option) {
			<mat-option [value]="option">
				{{ option }}
			</mat-option>
		}
	</mat-select>
  <mat-hint><span>{{ hint }}</span></mat-hint>
</mat-form-field>

